/**
 * Browser / WebRTC failures when the microphone cannot be opened (in use by another app,
 * exclusive mode, driver issues, unplugged device). The app cannot fix these; Zoom surfaces
 * them as unhandled promise rejections.
 */

import { flattenCaughtMessage } from './errorUtils'

/**
 * Matches getUserMedia / WebRTC "could not start audio source" (NotReadableError).
 * Kept strict so real integration bugs are not dropped.
 */
export function isExpectedAudioCaptureNotReadableError(reason: unknown): boolean {
  const message = flattenCaughtMessage(reason).toLowerCase()
  if (!message) {
    return false
  }
  return (
    message.includes('could not start audio source') &&
    message.includes('notreadableerror')
  )
}
